import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreIcon from '@mui/icons-material/Restore';

interface RestoreOrDeleteButtonProps {
  archived: boolean;
  onDelete?: () => void;
  onRestore?: () => void;
  edge?: 'end';
}

export default function RestoreOrDeleteButton({
  archived,
  onDelete,
  onRestore,
  edge,
}: RestoreOrDeleteButtonProps) {
  if (archived && onRestore) {
    return (
      <IconButton
        edge={edge}
        aria-label="restore"
        onClick={onRestore}
      >
        <RestoreIcon />
      </IconButton>
    );
  }

  if (onDelete) {
    return (
      <IconButton
        edge={edge}
        aria-label="delete"
        onClick={onDelete}
      >
        <DeleteIcon />
      </IconButton>
    );
  }

  return null;
}
